import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Represents the view for the managerial report.
 * Extends the JetView class from webix-jet.
 */
export default class recordTableInformeGerencialView extends JetView {
    /**
     * Configures the datatable view for the managerial report.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        return {
            view: 'datatable',
            select: true,
            columns: [
                {
                    id: 'package',
                    header: _('dav'),
                    fillspace: 2,
                    minWidth: 100,
                    sort: 'text',
                    format: dateFormat,
                },
                {
                    id: 'maintainer',
                    header: _('ID Usuario'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'architecture',
                    header: _('Transacción ID'),
                    width: 100,
                    sort: 'int',
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(),
            pager: 'pagerA',
            url: devConfig.geturlApi() + 'es/Financial/GetInformeGerencial',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners for filtering and user ID changes.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1);
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1);
        });
        this.on(this.app, 'user:id', (Id) => {
            grid.load(grid.data.url + '?id=' + Id);
        });
    }
}

// FILE DOCUMENTED
